<template>
  <v-container>
    <v-stepper class="ma-3" :value="activeStep">
      <v-stepper-header>
        <v-stepper-step :complete="connectDeviceComplete"
                        :step="CONNECT_DEVICE">
          Connect Device
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="selectPayloadComplete"
                        :step="SELECT_PAYLOAD">
          Select Payload
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="runExploitComplete"
                        :step="RUN_EXPLOIT">
          Run Exploit
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
        <v-layout row wrap>
        <v-flex lg7 xs12>
          <connect-device/>
        </v-flex>
        <v-flex lg5 xs12>
          <select-payload/>
        </v-flex>
        </v-layout>
    <run-exploit/>
    <v-divider class="ma-3"/>
    <v-layout row>
      <v-flex xs12>
        <log/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  CONNECT_DEVICE,
  SELECT_PAYLOAD,
  RUN_EXPLOIT
} from "../constants/steps";
import ConnectDevice from "./ConnectDevice.vue";
import SelectPayload from "./SelectPayload.vue";
import RunExploit from "./RunExploit.vue";
import Log from "./Log.vue";

export default {
  name: "fusee-gelee",
  data() {
    return {
      CONNECT_DEVICE,
      SELECT_PAYLOAD,
      RUN_EXPLOIT
    };
  },
  computed: {
    ...mapGetters([
      "connectDeviceComplete",
      "selectPayloadComplete",
      "runExploitComplete",
      "activeStep"
    ])
  },
  components: { Log, ConnectDevice, SelectPayload, RunExploit }
};
</script>
